// Wooden map options. Option ids are stored with orders, so they must never change.
export const WOODS = [
    { id: 1, name: 'Nyír', labelKey: 'editor.wood.birch', color: '#e8d3b0' },
    { id: 2, name: 'Juhar', labelKey: 'editor.wood.maple', color: '#d6b588' },
    { id: 3, name: 'Tölgy', labelKey: 'editor.wood.oak', color: '#a97f55' },
    { id: 4, name: 'Dió', labelKey: 'editor.wood.walnut', color: '#6b4a33' },
    { id: 5, name: 'Ében', labelKey: 'editor.wood.ebony', color: '#2b231e' },
    { id: 6, name: 'Tengerkék', labelKey: 'editor.wood.sea_blue', color: '#2f6fae' },
];

// the blue stain is only for the water (backplate)
export const NATURAL_WOODS = WOODS.filter((wood) => wood.id !== 6);
export const FRAME_WOODS = WOODS.filter((wood) => [1, 4, 5].includes(wood.id));

// Front to back. `key` is the selectedOptions field holding the layer's wood.
export const LAYERS = [
    { key: 'roadsWood', name: 'Utak rétege', labelKey: 'editor.wood_layer.roads', options: NATURAL_WOODS },
    { key: 'landWood', name: 'Szárazföld rétege', labelKey: 'editor.wood_layer.land', options: NATURAL_WOODS },
    { key: 'backplateWood', name: 'Hátlap (víz)', labelKey: 'editor.wood_layer.backplate_water', options: WOODS },
    { key: 'frameWood', name: 'Keret', labelKey: 'editor.frame.label', options: FRAME_WOODS },
];

// Wooden star map, front to back: cut letter ply, the shaped sky ply, then the backplate.
export const STAR_LAYERS = [
    { key: 'textWood', name: 'Felirat rétege', labelKey: 'editor.wood_layer.text', options: NATURAL_WOODS },
    { key: 'skyWood', name: 'Égbolt (kivágott, gravírozott)', labelKey: 'editor.wood_layer.sky', options: NATURAL_WOODS },
    { key: 'backplateWood', name: 'Hátlap', labelKey: 'editor.wood_layer.backplate', options: NATURAL_WOODS },
    { key: 'frameWood', name: 'Keret', labelKey: 'editor.frame.label', options: FRAME_WOODS },
];

export const woodById = (id) => WOODS.find((wood) => wood.id === id) || WOODS[0];
